import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { twitterIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';

interface TwitterShareRoundProps {
  message: string;
  url: string;
  className?: string;
}

export const TwitterShareRound: React.FunctionComponent<TwitterShareRoundProps> = ({
  message,
  url,
  className,
}) => {
  const handleClick = () => {
    const twitterHref = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      url,
    )}&text=${encodeURIComponent(message)}`;

    window.open(twitterHref, 'newwindow', 'width=600,height=300');
  };

  return (
    <IconButton
      className={`${styles.roundButton} ${className}`}
      onClick={handleClick}
    >
      <div className={classNames(styles.iconWrapper, styles.twitter)}>
        <Svg markup={twitterIcon} className={styles.icon} />
      </div>
      Twitter
    </IconButton>
  );
};
